import { PluggableApisService } from 'services/pluggableApis';
import BatchDataService from 'pages/Batch/sections/Context/BatchDataService';
import getRemoveBGSrcUrl from 'utils/common/getRemoveBGSrcUrl';
import { generateAiEditImage } from 'pages/Batch/sections/Sidebar/AIEditorTool/utils/generateAiEditImage';
import type { IAiEditParams } from 'types/store';

import type { IProcessResult } from './toolchain';

/**
 * Replays a recorded AI Editor preset step on one item: resolves the item's source to a CDN URL and
 * runs the generation with the step's params. The live (interactive) path uses useAIEditorGenerate;
 * both share generateAiEditImage. Server-side action — fetches the source by key, ignores the image arg.
 */
const aiEditProcess =
  (attrs: IAiEditParams) =>
  async (itemKey: string, isCancel: () => boolean): Promise<IProcessResult> => {
    if (isCancel()) {
      throw new Error('cancelled');
    }

    const item = await BatchDataService.getData(itemKey);
    const rawSourceUrl = await PluggableApisService.getSourceUrl(itemKey);
    const sourceUrl = await getRemoveBGSrcUrl(rawSourceUrl);

    const url = await generateAiEditImage({
      sourceUrl,
      prompt: attrs.prompt,
      modelId: attrs.modelId,
      aspectRatio: attrs.aspectRatio,
      referenceUrl: attrs.referenceUrl,
      sourceWidth: item?.source.width,
      sourceHeight: item?.source.height,
    });

    return { result: url };
  };

export default aiEditProcess;
